import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TenantsFilters } from '../../../commons/models/tenants';

@Component({
  selector: 'app-tenants-filters',
  templateUrl: './tenants-filters.component.html',
  styleUrls: ['./tenants-filters.component.scss']
})
export class TenantsFiltersComponent {
  @Output()
  onFilter: EventEmitter<TenantsFilters> = new EventEmitter();

  private _defaultFilters: TenantsFilters;
  filtersForm: FormGroup;

  constructor(private fb: FormBuilder) {
    this._createForm();
  }

  private _createForm() {
    let group = {
      search: "",
    }

    this.filtersForm = this.fb.group(group);
  }

  applyFilters() {
    this.onFilter.emit(this._getPayment());
  }

  private _getPayment(): TenantsFilters {
    let filters: TenantsFilters = {}
    if (this.filtersForm) {
      const values = this.filtersForm.value;
      filters.search = values.search;
    }
    return filters;
  }

  resetFilters() {
    this.filtersForm.reset();
    this.filtersForm.patchValue({
      search: "",
    });
    this._setDefaultValues();
    this.applyFilters();
  }

  get defaultFilters(): TenantsFilters {
    return this._defaultFilters;
  }

  @Input()
  set defaultFilters(defaultFilters: TenantsFilters) {
    this._defaultFilters = defaultFilters;
    this._setDefaultValues();
  }

  private _setDefaultValues() {
    if (this.defaultFilters) {
      if (this.filtersForm) {
        this.filtersForm.patchValue({
          search: this.defaultFilters.search,
        })
      }
    }
  }
}
